import styles from './ErrorBanner.module.css';

type ErrorBannerProps = {
  message: string;
  onRetry?: () => void;
};

export function ErrorBanner({ message, onRetry }: ErrorBannerProps) {
  return (
    <div className={styles.banner}>
      <div>{message}</div>
      {onRetry ? (
        <button type="button" onClick={onRetry}>
          再試行
        </button>
      ) : null}
    </div>
  );
}


